import React, { Component } from 'react'
import store from 'store'
import OrdersTable from './OrdersTable'
import { Pagination } from 'antd'
import SortOrders from '../filters/SortOrders'
import ExportOrders from './actions/ExportOrders'
import FilterOrders from "./filters/FilterOrders"
import { listOrderV2, getListBrand } from "../../../../services/api/3dApi"
import { getListRequests } from "../../../../services/api/RequestsService"

class OrdersContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            orders: [],
            total: 0,
            limit: 50,
            page: 1,
            pages: 1,
            loading: false,
            error: '',
            filters: {
                status: 'fully-done',
                type: '',
                size: '',
                marketplaces: [],
                namespace: [],
                production_status: 'unprinted',
                show_archive: 'hide_archive',
                total_item: '',
                typeId: '',
                order_number: [],
                autoAproved: '',
            },
            itemsRequest: [],
            listBrand: [],
            listBarcodeSelected: []
        }
    }

    componentDidMount() {
        const { type, production_status, status, commitBlock } = this.props
        const oldFilters = store.get('filters')

        this.setState({
            filters: {
                ...this.state.filters,
                type: type || '',
                production_status: production_status || (!!oldFilters && oldFilters.production_status) || 'unprinted',
                status: status || (!!oldFilters && oldFilters.status) || 'fully-done',
                ...(commitBlock ? { commitBlock } : {})
            }
        }, () => {
            this._fetchOrders()
            this._fetchBrand()
        })
    }

    _fetchItemsRequest = async (items) => {
        try {
            const payload = {
                barcodes: items
            }
            const { success, data, message } = await getListRequests(payload)
            if (!success) throw new Error(message)
            this.setState({
                itemsRequest: data.requests
            })
        } catch (e) {
            alert(e.message)
        }
    }

    _fetchOrders = async () => {
        const { requestCount } = this.state
        const nextCount = requestCount ? requestCount + 1 : 1

        this.setState({
            loading: true,
            isRefreshed: false,
            requestCount: nextCount
        })

        try {
            const { limit, page, filters } = this.state

            const params = {
                limit,
                page: page,
                ...filters,
            }
            const newTags = !!params.listTags && params.listTags.some(i => i === 'fba') ? [...params.listTags, 'FBA'] : params.listTags
            if (params.tags && newTags) params.tags = [...params.tags, ...newTags]
            if (newTags && !params.tags) params.tags = newTags
            if (newTags) delete params.listTags
            if(params.autoAproved === 'true') params.autoAproved = true
            if(params.autoAproved === 'false') params.autoAproved = false

            const { data: response } = await listOrderV2(params)
            const { data, success, message, error } = response

            if (nextCount !== this.state.requestCount) {
                return
            }

            if (!success) {
                throw new Error(message || error || 'Không tải được danh sách đơn')
            }

            const { orders, total, pages } = data

            const arrItems = orders.filter(itemF => (!!itemF.tags && itemF.tags !== undefined && itemF.tags.length > 0)).map(itemO => {
                return `#${itemO.marketplace}_${itemO.item_number}`
            })

            this.setState({
                orders,
                total,
                pages,
                loading: false,
                isRefreshed: true,
                error: '',
            }, () => {
                if (arrItems.length > 0) {
                    this._fetchItemsRequest(arrItems)
                }
            })
        } catch (e) {
            if (nextCount !== this.state.requestCount) {
                return
            }

            this.setState({
                orders: [],
                total: 0,
                pages: 1,
                loading: false,
                error: e.message || 'Không tải được danh sách đơn',
            })
        }
    }

    _fetchBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const { data: Data } = await getListBrand(payload)
            const { data, success, message } = Data
            const Brands = data.Brands.map(i => ({ value: i.name, label: i.name }))
            if (success) {
                this.setState({ ...this.state, listBrand: Brands })
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    _handlePageChange = (current) => {
        this.setState({
            page: current,
        }, this._fetchOrders)
    }

    _handleChangeFilter = (field, value) => {
        this.setState(({ filters }) => {
            if (field === 'brand' && value[0] === 'no brand') {
                return {
                    filters: {
                        ...filters,
                        [field]: 'no brand'
                    },
                    listBarcodeSelected: []
                }
            }
            if (field === 'brand' && value.length === 0) {
                delete filters.brand
                return filters
            }
            if (field === 'commitBlock' && value === '') {
                const newFilters = { ...filters }
                delete newFilters.commitBlock
                return {
                    filters: newFilters,
                    page: 1,
                    listBarcodeSelected: []
                }
            }
            return {
                filters: {
                    ...filters,
                    [field]: value,
                },
                page: 1,
                listBarcodeSelected: []
            }
        }, () => {
            this._fetchOrders()

            store.set('filters', this.state.filters)
        })
    }

    _handleChangeSize = (value) => {
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    size: value,
                },
                page: 1,
            }
        }, this._fetchOrders)
    }

    _handleChangeType = (field, value) => {
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    size: '',
                    [field]: value,
                },
                page: 1,
            }
        }, this._fetchOrders)
    }

    _handleChangeTypeID = (id) => {
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    typeId: id,
                }
            }
        })
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1,
        }, this._fetchOrders)
    }

    _handleChangeDate = (field, value) => {
        const cloneFilter = Object.assign({}, this.state.filters)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') delete cloneFilter[field]

        this.setState({
            filters: cloneFilter
        }, this._fetchOrders)
    }

    _handleChangeSelectedBarcode = barcodes => {
        const { orders } = this.state
        const listBarcodes = orders.filter(order => barcodes.includes(order._id)).map(item => `${item.marketplace}_${item.item_number}`)
        this.setState({
            listBarcodeSelected: listBarcodes
        })
    }

    render() {
        const { total, page, orders, error, filters, limit, isRefreshed, loading, itemsRequest, listBrand, listBarcodeSelected } = this.state
        return (
            <div className='OrdersContainer py-3'>
                <div className='mb-3 d-flex justify-content-end'>
                    <ExportOrders loading={loading} filters={filters} total={total} />
                </div>

                <div className='jumbotron p-3 mb-3'>
                    <FilterOrders
                        loading={loading}
                        total={total}
                        filters={filters}
                        listBrand={listBrand}
                        onChangeSize={this._handleChangeSize}
                        onChangeDate={this._handleChangeDate}
                        onChangeFilter={this._handleChangeFilter}
                        onChangeType={this._handleChangeType}
                        onChangeTypeID={this._handleChangeTypeID}
                        listBarcodeSelected={listBarcodeSelected}
                    />
                </div>

                <div className='d-flex justify-content-between align-items-center mb-3'>
                    <SortOrders field='sort' onSelected={this._handleChangeFilter} />
                    <Pagination current={page} total={total} pageSize={limit} onChange={this._handlePageChange}
                        className='text-right' showSizeChanger pageSizeOptions={['10', '20', '50', '100', '200']}
                        onShowSizeChange={this._handleShowSizeChange} />
                </div>

                <OrdersTable
                    orders={orders}
                    error={error}
                    filters={filters}
                    isOrdersRefreshed={isRefreshed}
                    loading={loading}
                    onFetchOrders={this._fetchOrders}
                    itemsRequest={itemsRequest}
                    handleChangeSelectedBarcode={this._handleChangeSelectedBarcode}
                    onChangeFilter={this._handleChangeFilter}
                />

                <Pagination current={page} total={total} pageSize={limit} onChange={this._handlePageChange}
                    className='text-right' showSizeChanger pageSizeOptions={['10', '20', '50', '100', '200']}
                    onShowSizeChange={this._handleShowSizeChange} />
            </div>
        )
    }
}

export default OrdersContainer
